var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.978,
    height: 96.351,
    viewBox: "0 0 71.978 96.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(726.756 -284.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(-851.33 -85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-1",
    d: "M79.388,14.667a7.335,7.335,0,1,1,7.257-7.335,7.3,7.3,0,0,1-7.257,7.335m0-11.214a3.88,3.88,0,1,0,3.8,3.879,3.845,3.845,0,0,0-3.8-3.879",
    transform: "translate(60.243 369.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-1",
    d: "M55.021,84.613h0a2.286,2.286,0,0,1-2.286-2.286v-35.4a2.286,2.286,0,1,1,4.572,0v35.4a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(71.839 342.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-1",
    d: "M117.63,84.613h0a2.286,2.286,0,0,1-2.286-2.286v-35.4a2.286,2.286,0,1,1,4.572,0v35.4a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(34.406 342.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-1",
    d: "M76.7,185.545h0a2.286,2.286,0,0,1-2.286-2.286V151.471a2.286,2.286,0,0,1,4.572,0v31.788a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(58.875 280.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-1",
    d: "M94.913,185.545h0a2.286,2.286,0,0,1-2.286-2.286V151.471a2.286,2.286,0,0,1,4.572,0v31.788a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(47.989 280.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-1",
    d: "M83.631,85.628H73a2.73,2.73,0,0,1-2.73-2.73V48.917A2.73,2.73,0,0,1,73,46.187H83.631a2.73,2.73,0,0,1,2.73,2.73V82.9a2.73,2.73,0,0,1-2.73,2.73",
    transform: "translate(61.354 341.825)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-813.46 -242.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M82.1,410.069a7.335,7.335,0,1,1,7.257-7.335,7.3,7.3,0,0,1-7.257,7.335m0-11.214a3.88,3.88,0,1,0,3.8,3.879,3.845,3.845,0,0,0-3.8-3.879",
    transform: "translate(58.618 132.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M79.421,580.947h0a2.286,2.286,0,0,1-2.286-2.286V546.873a2.286,2.286,0,0,1,4.572,0v31.788a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(57.251 42.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M97.63,580.947h0a2.286,2.286,0,0,1-2.286-2.286V546.873a2.286,2.286,0,0,1,4.572,0v31.788a2.286,2.286,0,0,1-2.286,2.286",
    transform: "translate(46.364 42.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M81.029,458.669V443.652a3.007,3.007,0,0,0-3.233-2.71H75.668a3.007,3.007,0,0,0-3.234,2.71v14.571a2.277,2.277,0,0,1-.075.581l-6.853,17.552c-.443,1.69,1.093,3.291,3.158,3.291H84.793c2.067,0,3.6-1.6,3.157-3.295Z",
    transform: "translate(64.25 104.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M51.162,478.8a1.906,1.906,0,0,1-1.774-2.6l6.854-17.552.189-14.933a1.9,1.9,0,0,1,1.9-1.874h.032a1.9,1.9,0,0,1,1.872,1.935L60,458.793a4.382,4.382,0,0,1-.13,1.016l-6.929,17.78a1.9,1.9,0,0,1-1.774,1.213",
    transform: "translate(73.919 104.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M119.322,478.8a1.9,1.9,0,0,1-1.774-1.213L110.7,460.036a4.38,4.38,0,0,1-.207-1.274l-.244-14.984a1.9,1.9,0,0,1,1.872-1.935h.032a1.9,1.9,0,0,1,1.9,1.874l.244,15.015,6.8,17.471a1.908,1.908,0,0,1-1.774,2.6",
    transform: "translate(37.456 104.269)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMf);
export default __webpack_public_path__ + "static/media/MF.8f7cda5d.svg";
export { ForwardRef as ReactComponent };